import script from "./SpaceCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpaceCard.vue?vue&type=script&setup=true&lang=ts"

import "./SpaceCard.vue?vue&type=style&index=0&id=8fcf04da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fcf04da"]])

export default __exports__